<template>
	<select2 
		:id="id"
		:name="name">
		<option 
			v-for="estado in estados" 
			v-bind:value="estado.codigo">
			{{estado.descripcion}}
		</option>
	</select2>
</template>
<script>
	export default {
		props: ['value', 'disabled', 'id', 'name', 'title'],

		mounted(){
			var vm = this
            
			$(this.$el)
			.val(this.value)
            .on('change', function () {
                vm.$emit('input', this.value)
            });

            this.$nextTick(() => {
		    	$(vm.$el).val(vm.value).trigger('change')
		    });
		},

		data(){
			return {
				estados: [
					{codigo: 'Soltero', descripcion:'Soltero'},
					{codigo: 'Casado', descripcion:'Casado'},
					{codigo: 'Viudo', descripcion:'Viudo'},
					{codigo: 'Divorciado', descripcion:'Divorciado'}
				]
			}
		},

		watch: {
            value: function (value) {
                $(this.$el).val(value).trigger('change');
            },

            disabled: function(value){
            	$(this.$el).attr('disabled', value);
            },

            id: function(value){
            	$(this.$el).attr('id', value);
            }
        },
	}
</script>